import React, { useState } from 'react';
import { Card, Col, Row, Button, ButtonGroup } from 'react-bootstrap';
import IconButton from 'components/common/IconButton';
import Divider from 'components/common/Divider';
import { MdNoteAdd } from 'react-icons/md';
import AjoutProduitModal from './ajoutWizard/ajoutFournisseurModal';

const etats = ['Actif', 'Archivé'];

const ProduitsHeader = () => {
  const [activeEtat, setActiveEtat] = useState('Actif');
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <AjoutProduitModal modalShow={showModal} setModalShow={setShowModal} />
      <Card className="mb-3">
        <Card.Body>
          <Row className="justify-content-between align-items-center">
            <Col md>
              <h5 className="mb-2 mb-md-0">Fournisseurs</h5>
            </Col>
            <Col xs="auto">
              <IconButton
                variant="falcon-default"
                size="sm"
                icon="file-export"
                className="me-1 mb-2 mb-sm-0"
                iconClassName="me-1"
              >
                Exporter
              </IconButton>
              <IconButton
                variant="falcon-default"
                size="sm"
                icon="file-import"
                className="mb-2 mb-sm-0"
              >
                Importer
              </IconButton>
              <Button
                variant="primary"
                size="sm"
                className="mx-1 mb-2 mb-sm-0"
                onClick={() => setShowModal(true)}
              >
                <MdNoteAdd />
                Ajouter
              </Button>
            </Col>
          </Row>
          <Divider />
          <Row>
            <ButtonGroup aria-label="etats-Achat">
              {etats.map((etat, index) => {
                return (
                  <Button
                    key={index}
                    variant={
                      activeEtat === etat ? 'primary' : 'outline-primary'
                    }
                    className="me-2 mb-1 d-inline-block"
                    style={{ flex: 'none' }}
                    onClick={() => setActiveEtat(etat)}
                  >
                    {etat}
                  </Button>
                );
              })}
            </ButtonGroup>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default ProduitsHeader;
